import React, { useState, useContext, useEffect, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { Container, Grid, Box, Typography, Divider, TablePagination } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { PageContext } from '../Context/PageProvider'
import { COLORS } from '../Stylesheet/theme'
import Header from '../Components/Header'
import RateTicketsHeader from '../Components/RateTicketsHeader'
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber'
import Moment from 'react-moment'
import MessageIcon from '../Components/MessageIcon'
import { ReactComponent as SnowIcon } from '../Utils/icons/snowflake.svg'
import { TablePaginationActions } from '../Components/CustomTable'

export const TicketRateIcon = (rate) => {
    const rates = []
    for (let i = 0; i < 5; i++) {
        rates.push(<SnowIcon style={{ color: rate > i ? COLORS.PRIMARY : COLORS.DARK_10, marginRight: 4 }} />)
    }
    return rates
}
function TicketRates({ t, history }) {
    const context = useContext(PageContext)
    const classes = useStyles()
    const [tickets, setTickets] = useState(null)
    const [dateRange, setDateRange] = useState(null)

    console.log('date range:', dateRange)

    const loadTickets = async (page = 1) => {
        try {
            const _tickets = await context.loadRatedTickets({ ...dateRange }, page)
            setTickets(_tickets)
        } catch (error) {
            console.log('Load rated tickets error:', error)
        }
    }

    useEffect(() => {
        loadTickets()
    }, [dateRange])

    if (tickets === null) return null
    return (
        <Container maxWidth="xl" className={classes.root}>
            <Header />
            <RateTicketsHeader rateAvg={tickets && tickets.rateAvg} onChangeDate={(value) => setDateRange(value)} />
            <Container maxWidth="md">
                {tickets && tickets.docs.length > 0 && tickets.docs.map((ticket, index) => (
                    <Fragment key={index}>
                        <Box component="div" className={classes.tableRoot}>
                            <Box component="div" className={classes.iconColumn}>
                                <MessageIcon icon={<ConfirmationNumberIcon style={{ color: '#fff' }} />} backgroundColor={COLORS.PRIMARY} />
                            </Box>
                            <Box component="div" className={classes.contentColumn}>
                                <Typography variant={'h2'} className={classes.title}>{ticket.ticketId}</Typography>
                                <Moment element={Typography} className={classes.date} format={'DD.MM.yyyy HH:mm'} date={ticket.createdDate} />
                            </Box>
                            <Box component="div" className={classes.ratesContainer}>
                                <Grid container justify="flex-end">
                                    {TicketRateIcon(ticket.rate)}
                                </Grid>
                            </Box>
                        </Box>
                        <Divider />
                    </Fragment>
                ))}
                {tickets && tickets.docs.length > 0 && <TablePagination
                    rowsPerPageOptions={[]}
                    colSpan={3}
                    count={tickets?.totalDocs || 0}
                    rowsPerPage={tickets?.limit || 0}
                    page={tickets?.page - 1 || 0}
                    labelRowsPerPage=""
                    onChangePage={(event, newPage) => loadTickets(newPage + 1)}
                    ActionsComponent={TablePaginationActions}
                />}
            </Container>
        </Container>
    )
}


const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0,
        backgroundColor: theme.palette.common.white
    },
    tableRoot: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        padding: theme.padding.small
    },
    iconColumn: {
        paddingRight: theme.padding.small
    },
    contentColumn: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },
    ratesContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    title: {
        marginBottom: theme.margin.extraSmall
    },
    date: {
        fontSize: 12,
        lineHeight: "16px",
        color: theme.palette.primary.dark_65,
    },
    divider: {
        backgroundColor: theme.palette.primary.dark10,
        height: 1,
        width: '100%'
    },
}))

export default withTranslation()(withRouter(TicketRates))